import typography from '@amblique/king-living/app/theme/foundations/typography';
import {
  SWIPER_INSTOCK_NAV_NEXT,
  SWIPER_INSTOCK_NAV_PREV,
  SWIPER_NAV_MOBILE,
  swiperNavMobileIconSize,
} from '@amblique/king-living/app/theme/foundations/swiper-nav-tokens';

const WantItSooner = {
  parts: [
    'root',
    'promoCard',
    'promoContent',
    'promoImageWrapper',
    'promoImage',
    'viewAllLink',
    'carouselSection',
    'carouselInner',
    'carouselHeading',
  ],
  baseStyle: {
    root: {
      marginTop: {base: 10, md: 12},
      marginBottom: {base: '8px', md: '16px'},
      width: '100%',
    },
    promoCard: {
      bg: 'white',
      borderWidth: '1px',
      borderColor: 'brandColors.primaryDarkLinen',
      borderRadius: 'base',
      overflow: 'hidden',
      flexDirection: 'row',
      alignItems: 'stretch',
      minHeight: '133px',
    },
    promoContent: {
      flex: 1,
      paddingLeft: 5,
      paddingY: 2,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      sx: {
        '& .amb-markup h3': {
          color: 'brandColors.greyscale90',
          fontVariantNumeric: 'lining-nums proportional-nums',
          fontFamily: 'body',
          fontSize: {base: 'sm', md: 'md'},
          fontStyle: 'normal',
          fontWeight: 'semibold',
          lineHeight: 'base',
          marginBottom: 0.5,
        },
        '& .amb-markup p': {
          color: 'brandColors.greyscale70',
          fontFamily: 'body',
          fontSize: {base: '1xs', lg: 'xs'},
          fontStyle: 'normal',
          fontWeight: 'normal',
          lineHeight: 'shorter',
          marginBottom: 0,
        },
      },
    },
    promoImageWrapper: {
      maxWidth: {base: '154px', md: '190px'},
      maxHeight: {base: '240px', md: 'none'},
      overflow: 'hidden',
    },
    promoImage: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
    viewAllLink: {
      marginTop: 2,
      color: 'brandColors.viewDetailsLink',
      fontFamily: 'body',
      fontSize: '1xs',
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: 'shorter',
      textDecoration: 'underline',
      textUnderlinePosition: 'from-font',
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      padding: 0,
      textAlign: 'left',
      _hover: {
        opacity: 0.8,
      },
    },
    carouselSection: {
      width: 'calc(100vw - var(--want-it-sooner-vw-nudge, 0))',
      marginLeft: 'calc(-50vw + 50%)',
      marginRight: 'calc(-50vw + 50%)',
      boxSizing: 'border-box',
      bg: 'white',
      scrollMarginTop: '0',
      overflow: 'hidden',
    },
    carouselInner: {
      maxWidth: '1440px',
      width: '100%',
      paddingX: {base: 5, lg: 20},
      paddingTop: {base: 12, md: 25},
      paddingBottom: {base: 8, md: 25},
      marginX: 'auto',
      boxSizing: 'border-box',
      overflow: 'hidden',
      sx: {
        '& .swiper-want-it-sooner': {
          overflow: 'unset',
        },
        '& .swiper-wrapper': {
          alignItems: 'flex-start',
          height: '100%',
          minHeight: {base: '479px', lg: '519px'},
        },
        '& > .swiper-navigation-pagination .swiper-button-disabled': {
          opacity: 0,
          pointerEvents: 'none',
        },
        '& .swiper-want-it-sooner > .swiper-navigation-pagination .swiper-button-disabled': {
          opacity: 0,
          pointerEvents: 'none',
        },
        '& .swiper-want-it-sooner > .swiper-navigation-pagination .swiper-button-prev, & .swiper-want-it-sooner > .swiper-navigation-pagination .swiper-button-next': {
          alignItems: 'center',
          backdropFilter: 'blur(15px)',
          bg: 'brandColors.greyscale20',
          borderRadius: 'full',
          display: 'flex',
          flexShrink: 0,
          height: '17.5',
          justifyContent: 'center',
          paddingTop: 3.5,
          paddingRight: 4,
          paddingBottom: 3.5,
          paddingLeft: 3.5,
          top: '205px',
          width: '17.5',
        },
        '& .swiper-want-it-sooner > .swiper-navigation-pagination .swiper-button-prev': {
          left: -8.75,
        },
        '& .swiper-want-it-sooner > .swiper-navigation-pagination .swiper-button-next': {
          right: -8.75,
        },
        '& .swiper-want-it-sooner .swiper': {
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
    },
    carouselHeading: {
      ...typography.textStyles.headingXL,
      color: {base: 'brandColors.greyscale', lg: 'brandColors.greyscale90'},
      fontStyle: 'normal',
      letterSpacing: {base: 'headingTight', lg: 'headingTighter'},
      marginBottom: {base: 12, md: 11},
    },
  },
};

export default WantItSooner;
